import * as React from 'react'
import { connect } from 'react-redux'
import type { Group, GroupId } from 'types/group'
import { openFolder } from '@disco/state-management/actions/ExplorerActions'
import { makeGetGroup } from '@disco/state-management/selectors/groups'
import CustomGroupDragWrapper from 'containers/CustomGroupDragWrapper'
import CustomGroupDropWrapper from 'containers/CustomGroupDropWrapper'
import ExplorerFolder from '../../folder'
import type { ExplorerPane } from 'types/explorer'

type OwnProps = {
  groupId: GroupId
  index: number
  appearance: string
  pane: ExplorerPane
}
type StateProps = {
  group: Group
  openFolder: typeof openFolder
}
type Props = OwnProps & StateProps

class GroupItem extends React.Component<Props> {
  render() {
    const { group, index, appearance, pane, openFolder } = this.props
    return (
      <CustomGroupDragWrapper group={group}>
        <CustomGroupDropWrapper
          group={group}
          onFileHover={() => {
            openFolder(pane, index, group)
          }}
        >
          <ExplorerFolder
            {...this.props}
            appearance={appearance}
            group={group}
            index={index}
            pane={pane}
          />
        </CustomGroupDropWrapper>
      </CustomGroupDragWrapper>
    )
  }
}

export default connect(
  (state, { groupId }: OwnProps) => {
    const getGroup = makeGetGroup()
    return {
      group: getGroup(state, {
        groupId,
      }),
    }
  },
  {
    openFolder,
  },
)(GroupItem) as any
